// extracted by mini-css-extract-plugin
module.exports = {"card":"SidebarMenuCard_card__16_JK","cardContent":"SidebarMenuCard_cardContent__14cOr","itemTitle":"SidebarMenuCard_itemTitle__1Nn8y"};